// @flow
import { postCreator } from '../../http';
import environment from '../../environment';

export type TicketRequest = {
  comments: string;
  email?: string;
  name?: string;
  orderId: string;
  phone?: string;
  motive: string;
  userId?: string;
};

export const endpoints = Object.freeze({
  CREATE_TICKET: `${environment.apiUrl}/report/issues`,
});

export const createTicketApi = postCreator(fetch, endpoints.CREATE_TICKET);



// WEBPACK FOOTER //
// ./src/modules/help-ticket/api.js